const Clinic = () => {
  return ( 
    <h2>Clinic</h2>
   );
}
 
export default Clinic;